import { render, staticRenderFns } from "./EditVisitTypeGroup.vue?vue&type=template&id=a8a16b18&scoped=true&"
import script from "./EditVisitTypeGroup.vue?vue&type=script&lang=js&"
export * from "./EditVisitTypeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a16b18",
  null
  
)

export default component.exports